export default "__VITE_ASSET__DoEHgBJ___"